/**
 * Map API response to dropdown options including "All" on top.
 * Returns object with stations, zones, divisions, assetsType, assetsNumber
 */
export const mapRequestDataToOptions = (response) => {
    const ALL = { label: 'ALL', value: 'all' };

    return {
        stations: [
            ALL,
            ...(response?.stations || []).map((s) => ({
                label: s.name,
                value: s.station_code,
                station_code: s.station_code, // optional extra info
            })),
        ],
        zones: [
            ALL,
            ...(response?.zones || []).map((z) => ({
                label: z.zone_name,
                value: z.zone_code,
            })),
        ],
        divisions: [
            ALL,
            ...(response?.divisions || []).map((d) => ({
                label: d.division_name,
                value: d.division_code,
            })),
        ],
        assetsType: [
            ALL,
            ...Array.from(new Set((response?.master || []).map((m) => m.asset_type_code))).map((code) => {
                const m = response.master.find((item) => item.asset_type_code === code);
                return {
                    label: m.asset_type_code,
                    value: m.asset_type_code,
                    sc: m.sc,
                };
            }),
        ],
        assetsNumber: [
            ALL,
            ...(response?.master || []).map((m) => ({
                label: m.asset_number_code,
                value: m.asset_type_code,
                sc: m.sc,
            })),
        ],
        causes: [
            ALL,
            ...(response?.causes || []).map((c) => ({
                label: c.code_name,
                value: c.code_name,
            })),
        ],
    };
};

export const sizePerPageList = [
    {
        text: '20',
        value: 20,
    },
    {
        text: '40',
        value: 40,
    },
    {
        text: '60',
        value: 60,
    },
    {
        text: '80',
        value: 80,
    },
];

export const alertSummaryColumns = [
    {
        Header: 'Sr Number',
        accessor: 'srNo',
    },
    {
        Header: 'Vendor Name',
        accessor: 'vcc',
    },
    {
        Header: 'Zone Code',
        accessor: 'zoneCode',
    },
    {
        Header: 'Division Code',
        accessor: 'divisionCode',
    },
    {
        Header: 'Station Code',
        accessor: 'stationCode',
    },
    {
        Header: 'Alert Type',
        accessor: 'alertType',
    },
    {
        Header: 'Asset Type',
        accessor: 'assetType',
    },
    {
        Header: 'Asset Number',
        accessor: 'assetNumber',
    },
    {
        Header: 'Cause Code',
        accessor: 'causeCode',
    },
    {
        Header: 'Total Count',
        accessor: 'totalCount',
    },
    {
        Header: 'True Count',
        accessor: 'trueCount',
    },
];

export const alertDetailsColumns = [
    { Header: 'Sr Number', accessor: 'srNo' },

    { Header: 'Vendor', accessor: 'vcc' },

    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },

    { Header: 'Alert Type', accessor: 'alertType' },
    { Header: 'Asset Type', accessor: 'assetType' },
    { Header: 'Asset Number', accessor: 'assetNumber' },

    { Header: 'Cause', accessor: 'causeCode' },
    { Header: 'Feedback', accessor: 'alertFeedback' },

    { Header: 'Incidence Time', accessor: 'incidenceDate' },
    { Header: 'Rectification Time', accessor: 'rectificationDate' },
    { Header: 'Duration', accessor: 'incidenceDuration' },

    { Header: 'Maintainer', accessor: 'maintainerName' },
    { Header: 'Remarks', accessor: 'remarks' },
];

export const TelemetryHistoryColumns = [
    { Header: 'Sr Number', accessor: 'srNo' },
    { Header: 'Vendor', accessor: 'vcc' },
    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },
    { Header: 'Asset Type', accessor: 'assetType' },
    { Header: 'Asset Number', accessor: 'assetNumber' },
    { Header: 'Parameter', accessor: 'parameterName' },
    { Header: 'Value', accessor: 'parameterValue' },
    { Header: 'Time', accessor: 'parameterTime' },
];

export const assetsColumns = [
    { Header: 'Sr Number', accessor: 'srNo' },

    { Header: 'Vendor Code', accessor: 'vcc' },
    { Header: 'Vendor Name', accessor: 'vcn' },

    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },

    { Header: 'Asset Type', accessor: 'assetType' },
    { Header: 'Asset Make', accessor: 'assetMake' },

    { Header: 'Total Count', accessor: 'totalCount' },
];
